import React, { FC } from 'react'
import styled from 'styled-components'
import { Fonts, Icon } from 'components/base-ui'

type Props = {
  label: string
  icon: string
  tooltipTitle: string
  tooltipDescription: string
}

const TextWithTooltip: FC<Props> = ({ icon, label, tooltipTitle, tooltipDescription }) => {
  return (
    <CheckoutTitle>
      {label}
      <IconWithTootip>
        <Icon name="carret-down-right-angle" size="7.2px" />
        <TootipBox className="tootip">
          <Icon style={{ paddingTop: 4 }} name={icon} size="12px" />
          <TooltipText>
            <Title>{tooltipTitle}</Title>
            <Description>{tooltipDescription}</Description>
          </TooltipText>
        </TootipBox>
        <TooltipQuoat className="tooltip-quoat" />
      </IconWithTootip>
    </CheckoutTitle>
  )
}

export default TextWithTooltip

const CheckoutTitle = styled(Fonts.SmallTitleRegular)`
  position: relative;
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.XS};
  color: #1662a8;
  font-size: 13px;
`

const IconWithTootip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover .tootip,
  &:hover .tooltip-quoat {
    visibility: visible;
  }
`

const TooltipQuoat = styled.div`
  visibility: hidden;
  width: ${({ theme }) => theme.spacing.XL};
  height: ${({ theme }) => theme.spacing.XL};
  background: ${({ theme }) => theme.colors.element.white};
  position: absolute;
  transform: rotate(45deg);
  bottom: ${({ theme }) => theme.spacing['2XL']};
  z-index: 99;
`

const TootipBox = styled.span`
  display: flex;
  column-gap: 5px;
  visibility: hidden;
  background: #ffffff;
  border-radius: 6px;
  padding: ${({ theme }) => theme.spacing.S};
  position: absolute;
  bottom: 25px;
  left: -20vw;
  right: -20vw;
  filter: drop-shadow(0px 0px 16px rgba(1, 1, 1, 0.2));
`

const TooltipText = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.gray800};
`

const Title = styled(Fonts.SmallTitleBold)`
  font-size: 13px;
`

const Description = styled(Fonts.SmallTitleRegular)`
  font-size: ${({ theme }) => theme.fontSize.sm};
`
